/**
 * add-order 这一次真的下成了吗（多版本菜单 B6 U-B6-2，research §1.4；review 第 1 轮 F1，owner D1 = A）。
 *
 * 几个下单方法（购物车挂账快捷下单 `_createTabPayOrder`、后付款追加 `AddOrder`）用 `.catch` 把拒单吞掉，
 * 调用方以前不看返回值，照样清车、付款、跳页。下成了的单，后端一定回这张单的数据（`VenueOrder::getData()`，带 `id`）。
 *
 * 没下成要分两种（owner D1 = A）：
 * - **明确没下成**（notPlaced）：后端回了 `success:false` —— 拦截器 reject 出后端的错误对象 / 一句话 / 错误码（`requestMixin.js`）；
 *   或者请求根本没发出去（预览本地拦下、页面自己的检查没过 ⇒ 返回 undefined）；或者回的根本不是一张单（`check result 2` 这句校验通过的串）。
 * - **不知道**（unknown）：拦截器网络分支 `Promise.reject()` 出来的 `undefined`（断网 / 超时 / 被取消，`requestMixin.js` 错误拦截器
 *   `!error.response` 那一支）、没有响应或 5xx 的 axios 错误（后端可能已经提交、回包时才出错）、处理响应的代码自己抛了（回的可能就是成功）。
 *   **追加**（后付款加单 / 加到未付挂账单上）在后端没有幂等，再点一次就把同样的东西追加两遍 ⇒ 不知道的时候照改动前去那张单的页面看服务器上的样子。
 */
import { isPreviewBlockedError } from './menu/previewRequest'

export const ORDER_PLACED = 'placed'
export const ORDER_NOT_PLACED = 'notPlaced'
export const ORDER_OUTCOME_UNKNOWN = 'unknown'

/**
 * @param {*} result addOrder 的返回值
 * @returns {Boolean}
 */
export function isPlacedOrder(result) {
  return !!result && typeof result === 'object' && !Array.isArray(result) && !!result.id
}

/**
 * add-order 的 promise reject 出来的值 → 明确没下成 / 不知道。
 * @param {*} error
 * @returns {'notPlaced'|'unknown'}
 */
export function addOrderFailureOutcome(error) {
  // 网络分支 reject 的就是 undefined（null 不会出现，同样当说不清）
  if (error === undefined || error === null) return ORDER_OUTCOME_UNKNOWN
  // 后端的一句话 / 错误码（拦截器 `Promise.reject(code)` / `error.message || error`）
  if (typeof error !== 'object') return ORDER_NOT_PLACED
  // 预览时请求拦截器本地拦下：根本没发出去
  if (isPreviewBlockedError(error)) return ORDER_NOT_PLACED
  // axios 错误（拦截器对有响应的 HTTP 错误原样 reject）：没有响应 / 5xx ⇒ 后端可能已经提交；4xx ⇒ 后端拒了
  if (error.isAxiosError === true || (error.config && ('request' in error || 'response' in error))) {
    const status = error.response && error.response.status
    return !status || status >= 500 ? ORDER_OUTCOME_UNKNOWN : ORDER_NOT_PLACED
  }
  // 不是后端的错误对象，是代码自己抛的（处理响应时出错：回的可能就是成功）
  if (error instanceof Error) return ORDER_OUTCOME_UNKNOWN
  // 后端的错误对象 {type, message, info, code?}（含 U-B6-1 挂上的 soldOut）
  return ORDER_NOT_PLACED
}

/** `.catch` 里换成这个：不是订单（没有 id），记着这次是「明确没下成」还是「不知道」 */
export function failedOrder(error) {
  return { orderOutcome: addOrderFailureOutcome(error) }
}

/**
 * addOrder 的结果（订单 / `failedOrder` 标记 / 别的）→ 下成了 / 明确没下成 / 不知道。
 * undefined（页面自己的检查没过、请求没发）与不是订单的回答（`check result 2`）都是明确没下成。
 * @returns {'placed'|'notPlaced'|'unknown'}
 */
export function orderOutcomeOf(result) {
  if (isPlacedOrder(result)) return ORDER_PLACED
  if (result && typeof result === 'object' && result.orderOutcome === ORDER_OUTCOME_UNKNOWN) return ORDER_OUTCOME_UNKNOWN
  return ORDER_NOT_PLACED
}
